import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
/**
 * TOP: 共通のスライダー項目（要素幅やスペーシングを統一するためのコンポーネント）
 * @param props
 * @returns
 */
export const TopBaseSliderItem = (props) => {
    const { children, className = '', innerClassName = '' } = props;
    return (_jsx("div", Object.assign({ className: clsx('px-4 lg:px-16 py-[6px]', className) }, { children: _jsx("div", Object.assign({ className: clsx('w-[280px] xs:w-[305px] lg:w-[320px]', innerClassName) }, { children: children })) })));
};
